import { fetchCategories, selectCategory, resetCurrentCategory, editMultiCategories, deleteCategory, clearDeleteCategoryStatus, fetchGroupCategories } from '../../actions/products_actions';
import { connect } from 'react-redux';

import Categories from '../../components/Products/categories'

function mapStateToProps(state) {
    return {
        categories: state.products.groupCategories,
        categoryIsLoading: state.products.groupCategoryIsLoading,
        categoryError: state.products.groupCategoryError,
        currentCategory: state.products.currentCategory,
        multiIsEditing: state.products.multiCategoryIsEditing,
        multiError: state.products.multiCategoryEditError,
        multiEdited: state.products.multiCategoryEdited,
        userPermissions: state.auth.userPermissions,
        deletingCategory: state.products.deletingCategory,
        deleteCategorySuccess: state.products.deleteCategorySuccess,
        deleteCategoryError: state.products.deleteCategoryError,
        currentGroup: state.products.currentGroup,
    };
}

export default connect(mapStateToProps, { fetchCategories, selectCategory, resetCurrentCategory, editMultiCategories, deleteCategory, clearDeleteCategoryStatus, fetchGroupCategories })(Categories);



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/categories.jsx